import React from 'react';

import BuildTime from './BuildTime';
import ce from './images/ce.svg';
import manufacturer from './images/manufacturer.png';
import manufacturingDate from './images/manufacturingDate.png';
import udi from './images/udi.png';

function HelpSE() {
  return (
    <main id="instructions" className="textPage">
      <h1>Säkerhetsinformation - Sensotrend Dashboard</h1>
      <section>
        <h3>Avsedda ändamål av applikationen</h3>
        <p>
          Sensotrend Dashboard underlättar behandlingen av diabetes genom att tillhandahålla
          information som används för att övervaka balansen i vården och fatta behandlingsbeslut.
          Tjänsten kombinerar information om medicintekniska produkter och wellnessapplikationer
          och visualiserar informationen på ett sätt som illustrerar effekterna av olika faktorer
          på blodsockernivån. Tjänsten är avsedd att användas av patienter, vårdpersonal och andra
          som är involverade i behandlingen.
        </p>
        <p>
          Sensotrend Dashboard är utformad för diabetiker som ansvarar för deras vård. Vi vill dock
          inte begränsa användningen av applikationen till endast denna grupp användare. När det
          gäller andra användargrupper anser vi att den som ansvarar för vården också är ansvarig
          för användningen av Sensotrend Dashboard.
        </p>
        <p>
          Deltagande av familjemedlemmar eller peer grupp i användningen av applikationen är
          tillåten med tillstånd från användaren av applikationen. Detta inkluderar möjligheten att
          ge familjemedlemmar eller peer support visningstillstånd för den hälsoinformation som
          visas i appen.
        </p>
      </section>
      <section>
        <h3>Begränsningar</h3>
        <p>
          Applikationen är inte avsedd för realtidsövervakning av hälsotillstånd.
        </p>
        <p>
          Användningen av applikationen ersätter inte vården som tillhandahålls av en vårdpersonal
          utan kompletterar den. Om det finns betydande förändringar i din vårdbalans, kontakta din
          vårdgivare.
        </p>
        <p>
          Gör inte betydande förändringar i din behandling baserat på informationen som
          tillhandahålls av Sensotrend Dashboard ensam. Innan du fattar ett behandlingsbeslut ska
          data från Sensotrend Dashboard jämföras med data från den ursprungliga datakällan för att
          säkerställa att hela dataöverföringskedjan har fungerat tillförlitligt.
        </p>
        <p>
          Om allvarliga incidenter inträffar under användningen av applikationen ska de rapporteras
          till vår kundsupport på <a href="mailto:support@sensotrend.com">support@sensotrend.com
          </a> och tillsynsmyndigheten.
        </p>
        <h3>Information relaterad till systemkrav</h3>
        <p>
          Sensotrend Dashboard är utformat för att fungera med moderna IT-verktyg och de mest
          använda webbläsarna. Det är dock inte möjligt att säkerställa att applikationen fungeres
          med alla konfigurationer  på marknaden. Om du märker någon felaktig, oväntad eller
          ofullständig aktivitet som kan bero på hårdvaran eller programvaran du använder, vänligen
          kontakta vår kundsupport på <a href="mailto:support@sensotrend.com">
          support@sensotrend.com</a> så att vi kan lösa och, om möjligt, rätta till problemet.
        </p>
        <p>
          Om applikationen verkar fungera felaktigt på din enhet bör du omedelbart sluta använda
          den för att övervaka din hälso- och vårdbalans.
        </p>
      </section>
      <aside id="label">
        {/* This section includes the label. 
          Ref. MDR annex XIV, clause 1, 3rd bullet, and annex I, clause 23.2.
        */}
        <h2>Produktinformation</h2>
        {/* This clause is for MDR, annex I, clause 23.2, subclauses a) and b).*/}
        <p>Sensotrend Dashboard {`v.${process.env.REACT_APP_VERSION}`}</p>
        {/* This clause is for MDR, annex I, clause 23.2, subclause q).*/}

        <section id="ce">
          <figure>
            <img alt="CE" src={ce} />
          </figure>
          <p>Sensotrend Dashboard är en medicinsk produkt av klass I.</p>
          <p>
            Se <a href={`${
              process.env.PUBLIC_URL
            }/DECO-T5-DC-MDD_EU_Declaration_of_Conformity_-_signed.pdf`}
           >försäkran om överensstämmelse</a>.
          </p>
        </section>
        <section id="device">
            {/* This clause is for MDR, annex I, clause 23.2, subclause h).*/}
          <img alt="Laitetunniste" title="Laitetunniste" src={udi} />
          <p>D-FIMF000000500SD000001GS</p>
        </section>
        <section id="date">
            {/* Date of manufacture is for MDR, annex I, clause 23.2, subclause j).
              Date format is specified in ISO 1041:2008 & A1:2013, clause 4.4.
            */}
          <img alt="Valmistuspäivä" title="Valmistuspäivä" src={manufacturingDate} />
          {BuildTime}
        </section>
        <section id="manufacturer">
          <img alt="Valmistaja" title="Valmistaja" src={manufacturer} />
          <address>Sensotrend Oy<br />
            Tampellan esplanadi 19 A 55<br />
            33180 Tammerfors<br />
            Finland<br />
            <a href="mailto:support@sensotrend.com">support@sensotrend.com</a>
          </address>
        </section>
      </aside>
      <footer>
        {/* The date is for MDR, annex I, clause 23.4, subclause y).
            Date format is specified in ISO 1041:2008 & A1:2013, clause 4.4.
        */}
        <small>2021-06-11</small>
      </footer>
    </main>
  );
}

export default HelpSE;
